module.exports = __webpack_public_path__ + "static/media/Boopitdemo.5e31a5cd.mp4";